import { motion } from "framer-motion";
import { FaTelegram } from "react-icons/fa";
import CountdownTimer from "./CountdownTimer";

const TELEGRAM_LINK = "https://t.me/thegoldcastai";

export default function HeroSection({ onCtaClick }) {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[85vh] flex flex-col justify-center items-center text-center px-4 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="/hero-bg.png"
          alt="Trading background"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-[#0A0A0A]/80 to-[#0A0A0A]" />
      </div>

      {/* Logo */}
      <motion.div
        className="relative z-10 mb-4"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <img src="/fira-logo.jpg" alt="Fira Worldwide" className="w-16 h-16 rounded-full object-cover" style={{ boxShadow: "0 0 20px rgba(255,0,127,0.3)" }} />
      </motion.div>

      {/* Brand */}
      <motion.div
        className="relative z-10 mb-6"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15 }}
      >
        <span className="text-[#FF007F] font-bold text-lg tracking-widest uppercase font-mono">
          Fira Worldwide
        </span>
      </motion.div>

      {/* Title */}
      <motion.h1
        className="relative z-10 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter uppercase max-w-4xl leading-[1.05]"
        style={{ fontFamily: "Outfit, sans-serif" }}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.25 }}
      >
        27 <span className="text-[#FF007F]">BRUTAL TRUTHS</span>
        <br />
        <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#A1A1AA]">
          About Why You're Still Losing in Trading
        </span>
      </motion.h1>

      {/* Subtitle */}
      <motion.p
        className="relative z-10 mt-6 text-base sm:text-lg text-[#71717A] max-w-xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
      >
        And how you can avoid it. Scroll down to discover each truth.
      </motion.p>

      {/* Countdown */}
      <motion.div
        className="relative z-10 mt-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
      >
        <p className="text-[#71717A] text-xs tracking-widest uppercase mb-3">Something big is coming</p>
        <CountdownTimer />
      </motion.div>

      {/* CTA */}
      <motion.a
        href={TELEGRAM_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="hero-cta-btn"
        onClick={onCtaClick}
        className="relative z-10 mt-6 flex items-center gap-3 bg-[#FF007F] text-white font-bold py-4 px-8 rounded-full text-lg hover:bg-[#E60073] transition-all duration-300 hover:scale-105"
        style={{ boxShadow: "0 0 30px rgba(255,0,127,0.4)" }}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, delay: 0.75 }}
      >
        <FaTelegram size={24} />
        Join the Waiting Room
      </motion.a>

      {/* Scroll hint */}
      <motion.div
        className="absolute bottom-8 z-10"
        animate={{ y: [0, 8, 0] }}
        transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
      >
        <div className="w-6 h-10 rounded-full border-2 border-[#71717A] flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 rounded-full bg-[#FF007F]" />
        </div>
      </motion.div>
    </section>
  );
}
